import { View } from 'react-native';
import { Button } from 'react-native-paper';

export function CustomButton(props) {
  if (!props) {
    props = {};
  } else {
    props = Object.assign({}, props);
  }
  if (props.disabled) {
    //props.mode = "outlined";
  }
  // https://callstack.github.io/react-native-paper/docs/components/Button/
  return (
    <View style={{ display: 'flex', flexDirection: 'row', ...props.style }}>
      <Button
        mode="contained"
        {...props}
      />
    </View>
  );
}
